import { z } from 'zod';

export const ProductTypeEnum = {
    PRODUCT_SET: 'PRODUCT_SET',
    MONO_SKU: 'MONO_SKU',
    MULTI_SKU_SIZE: 'MULTI_SKU_SIZE',
    MULTI_SKU_SHADE_UNI: 'MULTI_SKU_SHADE_UNI',
    MULTI_SKU_SHADE_DIFF: 'MULTI_SKU_SHADE_DIFF',
} as const;

export const ProductTypeDTO = z.enum([
    ProductTypeEnum.PRODUCT_SET,
    ProductTypeEnum.MONO_SKU,
    ProductTypeEnum.MULTI_SKU_SIZE,
    ProductTypeEnum.MULTI_SKU_SHADE_UNI,
    ProductTypeEnum.MULTI_SKU_SHADE_DIFF,
]);

export type ProductTypeDTO = z.infer<typeof ProductTypeDTO>;
